module.exports = "https://portperrypedals.ca/_res/img/dark-logo-reversed.ce7b202.png";